export default __webpack_public_path__ + "static/dairy-free-health-2-mobile-ae039cfcdcff7ecc3c8015017adf37ec.png";